import {apiGet, apiPost} from "../services/apiClient";

export const getColumns = (name) => {
  return apiGet(`${name}/grid/columns`)
}

export const getList = (name, data, isGrid) => {
  return apiPost(`${name}${isGrid ? '/grid' : ''}/list`, data)
}

export const getSelectOptions = (name, data) => {
  return apiPost(`parcels/grid/ref/${name}`, data)
}
export const getDataByUrl = (url) => {
  return apiGet(url)
}
export const getCard = (name, id) => {
  return apiGet(`${name}/${id}`)
}


// WEBPACK FOOTER //
// ./App/grids/api.jsx